import { render } from "./MatchRecapPage.vue?vue&type=template&id=80e2694e&scoped=true"
import script from "./MatchRecapPage.vue?vue&type=script&lang=js"
export * from "./MatchRecapPage.vue?vue&type=script&lang=js"

import "./MatchRecapPage.vue?vue&type=style&index=0&id=80e2694e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80e2694e"]])

export default __exports__